import { render, staticRenderFns } from "./CoursePackageContent.vue?vue&type=template&id=4533a3dd&scoped=true"
import script from "./CoursePackageContent.vue?vue&type=script&lang=js"
export * from "./CoursePackageContent.vue?vue&type=script&lang=js"
import style0 from "./CoursePackageContent.vue?vue&type=style&index=0&id=4533a3dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4533a3dd",
  null
  
)

export default component.exports